import { cn } from "../../../lib/cn";

const STEPS = [
  { key: "services", label: "Service" },
  { key: "time", label: "Date & Time" },
  { key: "contact", label: "Confirm" },
] as const;

type StepKey = "services" | "time" | "contact" | "success";
const ORDER: StepKey[] = ["services", "time", "contact"];

type StepperStyle = {
  variant?: "numbers" | "dots";
  showLabels?: boolean;
};

export function ProgressBar({ current, styleConfig }: { current: StepKey; styleConfig?: StepperStyle }) {
  const idx = current === "success" ? 3 : ORDER.indexOf(current);
  const variant = styleConfig?.variant || "numbers";
  const showLabels = styleConfig?.showLabels ?? true;

  return (
    <div className="flex items-center justify-center gap-0 py-4 px-2">
      {STEPS.map((step, i) => {
        const completed = i < idx;
        const active = i === idx;

        return (
          <div key={step.key} className="flex items-center">
            {i > 0 && (
              <div
                className={cn(
                  "w-8 sm:w-12 h-0.5 mx-1",
                  completed ? "bg-teal-600" : "bg-slate-200"
                )}
              />
            )}
            <div className="flex flex-col items-center gap-1">
              <div
                className={cn(
                  "w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-transform",
                  completed && "bg-teal-600 text-white",
                  active && "bg-teal-600 text-white",
                  !completed && !active && (variant === "dots" ? "bg-slate-200 text-transparent" : "border-2 border-slate-300 text-slate-400"),
                  variant === "dots" && (active ? "scale-110" : "w-3 h-3")
                )}
                data-testid={`step-indicator-${step.key}`}
              >
                {completed ? (
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : variant === "numbers" ? (
                  i + 1
                ) : (
                  <span className="sr-only">{step.label}</span>
                )}
              </div>
              {showLabels && (
                <span
                  className={cn(
                    "text-xs hidden sm:block",
                    completed || active ? "text-teal-700 font-semibold" : "text-slate-400"
                  )}
                >
                  {step.label}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
